export const FUNDING_SUCCESS_KIND = {
  PORTFOLIO: 'portfolio',
  EXPERT_PORTFOLIO: 'expertPortfolio',
}
